

function App() {
  return (
    <>
      <>
        {/* Theme Setting Star */}
        <div className="theme-controller">
          <div className="color-picker">
            <input
              type="color"
              className="form-control form-control-color"
              id="ColorPicker1"
              defaultValue="#d97819"
              title="Choose your color"
            />
          </div>
          <div className="light-dark-box">
            <button id="dark-btn" className="btnTheme">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-moon"
              >
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>{" "}
              <span className="text-value">Dark</span>
            </button>
            <button id="rtl-btn" className="btnTheme ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-repeat"
              >
                <polyline points="17 1 21 5 17 9" />
                <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                <polyline points="7 23 3 19 7 15" />
                <path d="M21 13v2a4 4 0 0 1-4 4H3" />
              </svg>{" "}
              <span className="text-value">Rtl</span>
            </button>
          </div>
        </div>
        {/* Theme Setting End */}
        {/* Loader Start */}
        <div className="loader-wrapper hidden">
          <div className="loader">
            <span>O</span>
            <span>S</span>
            <span>L</span>
            <span>O</span>
          </div>
        </div>
        {/* Loader End */}
        {/* Overlay */}
        <a href="javascript:void(0)" className="overlay-general" />
        {/* Header Start */}
        <header className="header-common header1 bg-theme-bk-l clone">
          {/* Top Header */}
          <div className="top-header">
            <div className="container-lg">
              <div className="topheader-wrap">
                <ul className="social-list">
                  <li>
                    <a href="https://www.facebook.com/">
                      {" "}
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" color="white" viewBox="0 0 50 50">
                        <path d="M 30.140625 2 C 26.870375 2 24.045399 2.9969388 22.0625 4.9667969 C 20.079601 6.936655 19 9.823825 19 13.367188 L 19 18 L 13 18 A 1.0001 1.0001 0 0 0 12 19 L 12 27 A 1.0001 1.0001 0 0 0 13 28 L 19 28 L 19 47 A 1.0001 1.0001 0 0 0 20 48 L 28 48 A 1.0001 1.0001 0 0 0 29 47 L 29 28 L 36 28 A 1.0001 1.0001 0 0 0 36.992188 27.125 L 37.992188 19.125 A 1.0001 1.0001 0 0 0 37 18 L 29 18 L 29 14 C 29 12.883334 29.883334 12 31 12 L 37 12 A 1.0001 1.0001 0 0 0 38 11 L 38 3.3457031 A 1.0001 1.0001 0 0 0 37.130859 2.3554688 C 36.247185 2.2382213 33.057174 2 30.140625 2 z M 30.140625 4 C 32.578477 4 34.935105 4.195047 36 4.2949219 L 36 10 L 31 10 C 28.802666 10 27 11.802666 27 14 L 27 19 A 1.0001 1.0001 0 0 0 28 20 L 35.867188 20 L 35.117188 26 L 28 26 A 1.0001 1.0001 0 0 0 27 27 L 27 46 L 21 46 L 21 27 A 1.0001 1.0001 0 0 0 20 26 L 14 26 L 14 20 L 20 20 A 1.0001 1.0001 0 0 0 21 19 L 21 13.367188 C 21 10.22255 21.920305 7.9269075 23.472656 6.3847656 C 25.025007 4.8426237 27.269875 4 30.140625 4 z"></path>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/i/flow/login">
                      {" "}
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" color="white" viewBox="0 0 50 50">
                        <path d="M 34.21875 5.46875 C 28.238281 5.46875 23.375 10.332031 23.375 16.3125 C 23.375 16.671875 23.464844 17.023438 23.5 17.375 C 16.105469 16.667969 9.566406 13.105469 5.125 7.65625 C 4.917969 7.394531 4.597656 7.253906 4.261719 7.277344 C 3.929688 7.300781 3.632813 7.492188 3.46875 7.78125 C 2.535156 9.386719 2 11.234375 2 13.21875 C 2 15.621094 2.859375 17.820313 4.1875 19.625 C 3.929688 19.511719 3.648438 19.449219 3.40625 19.3125 C 3.097656 19.148438 2.726563 19.15625 2.425781 19.335938 C 2.125 19.515625 1.941406 19.839844 1.9375 20.1875 L 1.9375 20.3125 C 1.9375 23.996094 3.84375 27.195313 6.65625 29.15625 C 6.625 29.152344 6.59375 29.164063 6.5625 29.15625 C 6.21875 29.097656 5.871094 29.21875 5.640625 29.480469 C 5.410156 29.742188 5.335938 30.105469 5.4375 30.4375 C 6.554688 33.910156 9.40625 36.5625 12.9375 37.53125 C 10.125 39.203125 6.863281 40.1875 3.34375 40.1875 C 2.582031 40.1875 1.851563 40.148438 1.125 40.0625 C 0.65625 40 0.207031 40.273438 0.0507813 40.71875 C -0.109375 41.164063 0.0664063 41.660156 0.46875 41.90625 C 4.980469 44.800781 10.335938 46.5 16.09375 46.5 C 25.425781 46.5 32.746094 42.601563 37.65625 37.03125 C 42.566406 31.460938 45.125 24.226563 45.125 17.46875 C 45.125 17.183594 45.101563 16.90625 45.09375 16.625 C 46.925781 15.222656 48.5625 13.578125 49.84375 11.65625 C 50.097656 11.285156 50.070313 10.789063 49.777344 10.445313 C 49.488281 10.101563 49 9.996094 48.59375 10.1875 C 48.078125 10.417969 47.476563 10.441406 46.9375 10.625 C 47.648438 9.675781 48.257813 8.652344 48.625 7.5 C 48.75 7.105469 48.613281 6.671875 48.289063 6.414063 C 47.964844 6.160156 47.511719 6.128906 47.15625 6.34375 C 45.449219 7.355469 43.558594 8.066406 41.5625 8.5 C 39.625 6.6875 37.074219 5.46875 34.21875 5.46875 Z M 34.21875 7.46875 C 36.769531 7.46875 39.074219 8.558594 40.6875 10.28125 C 40.929688 10.53125 41.285156 10.636719 41.625 10.5625 C 42.929688 10.304688 44.167969 9.925781 45.375 9.4375 C 44.679688 10.375 43.820313 11.175781 42.8125 11.78125 C 42.355469 12.003906 42.140625 12.53125 42.308594 13.011719 C 42.472656 13.488281 42.972656 13.765625 43.46875 13.65625 C 44.46875 13.535156 45.359375 13.128906 46.3125 12.875 C 45.457031 13.800781 44.519531 14.636719 43.5 15.375 C 43.222656 15.578125 43.070313 15.90625 43.09375 16.25 C 43.109375 16.65625 43.125 17.058594 43.125 17.46875 C 43.125 23.71875 40.726563 30.503906 36.15625 35.6875 C 31.585938 40.871094 24.875 44.5 16.09375 44.5 C 12.105469 44.5 8.339844 43.617188 4.9375 42.0625 C 9.15625 41.738281 13.046875 40.246094 16.1875 37.78125 C 16.515625 37.519531 16.644531 37.082031 16.511719 36.683594 C 16.378906 36.285156 16.011719 36.011719 15.59375 36 C 12.296875 35.941406 9.535156 34.023438 8.0625 31.3125 C 8.117188 31.3125 8.164063 31.3125 8.21875 31.3125 C 9.207031 31.3125 10.183594 31.1875 11.09375 30.9375 C 11.53125 30.808594 11.832031 30.402344 11.816406 29.945313 C 11.800781 29.488281 11.476563 29.097656 11.03125 29 C 7.472656 28.28125 4.804688 25.382813 4.1875 21.78125 C 5.195313 22.128906 6.226563 22.402344 7.34375 22.4375 C 7.800781 22.464844 8.214844 22.179688 8.355469 21.746094 C 8.496094 21.3125 8.324219 20.835938 7.9375 20.59375 C 5.5625 19.003906 4 16.296875 4 13.21875 C 4 12.078125 4.296875 11.03125 4.6875 10.03125 C 9.6875 15.519531 16.6875 19.164063 24.59375 19.5625 C 24.90625 19.578125 25.210938 19.449219 25.414063 19.210938 C 25.617188 18.96875 25.695313 18.648438 25.625 18.34375 C 25.472656 17.695313 25.375 17.007813 25.375 16.3125 C 25.375 11.414063 29.320313 7.46875 34.21875 7.46875 Z"></path>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/accounts/login/?source=auth_switcher">
                      {" "}
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" color="white" viewBox="0 0 50 50">
                        <path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="https://in.pinterest.com/">
                      {" "}
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" color="white" viewBox="0 0 50 50">
                        <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609825 4 46 13.390175 46 25 C 46 36.609825 36.609825 46 25 46 C 22.876355 46 20.82771 45.682142 18.896484 45.097656 C 19.75673 43.659418 20.867347 41.60359 21.308594 39.90625 C 21.570728 38.899887 22.648438 34.794922 22.648438 34.794922 C 23.348841 36.132057 25.395277 37.263672 27.574219 37.263672 C 34.058123 37.263672 38.732422 31.300682 38.732422 23.890625 C 38.732422 16.78653 32.935409 11.472656 25.476562 11.472656 C 16.196831 11.472656 11.271484 17.700825 11.271484 24.482422 C 11.271484 27.636307 12.94892 31.562193 15.634766 32.8125 C 16.041611 33.001865 16.260073 32.919834 16.353516 32.525391 C 16.425459 32.226044 16.788267 30.766792 16.951172 30.087891 C 17.003269 29.871239 16.978043 29.68405 16.802734 29.470703 C 15.913793 28.392399 15.201172 26.4118 15.201172 24.564453 C 15.201172 19.822048 18.791452 15.232422 24.908203 15.232422 C 30.18976 15.232422 33.888672 18.832872 33.888672 23.980469 C 33.888672 29.796219 30.95207 33.826172 27.130859 33.826172 C 25.020554 33.826172 23.440361 32.080359 23.947266 29.939453 C 24.555054 27.38426 25.728516 24.626944 25.728516 22.78125 C 25.728516 21.130713 24.842754 19.753906 23.007812 19.753906 C 20.850369 19.753906 19.117188 21.984457 19.117188 24.974609 C 19.117187 26.877359 19.761719 28.166016 19.761719 28.166016 C 19.761719 28.166016 17.630543 37.176514 17.240234 38.853516 C 16.849091 40.52931 16.953851 42.786365 17.115234 44.466797 C 9.421139 41.352465 4 33.819328 4 25 C 4 13.390175 13.390175 4 25 4 z"></path>
                      </svg>
                    </a>
                  </li>
                </ul>
                <p className="marquee">
                  <span> Summer sale for all swim suits - off 50%! Shop Now</span>
                </p>
                <div className="select-menu">
                  <div className="dropdown select-dropdown">
                    <button id="unitSelected">
                      <span>USD</span>{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-chevron-down"
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </button>
                    <ul className="onhover-show-div">
                      <li className="unit">USD</li>
                      <li className="unit">EUR</li>
                      <li className="unit">INR</li>
                      <li className="unit">CNY</li>
                    </ul>
                  </div>
                  <div className="dropdown select-dropdown">
                    <button id="languageSelected">
                      <span>English</span>{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-chevron-down"
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </button>
                    <ul className="onhover-show-div">
                      <li className="lang">English</li>
                      <li className="lang">Chinese</li>
                      <li className="lang">Arabic</li>
                      <li className="lang">Russian</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-lg">
            <div className="nav-wrap">
              {/* Navigation Start */}
              <nav className="navigation">
                <div className="nav-section">
                  <div className="header-section">
                    <div className="navbar navbar-expand-xl navbar-light navbar-sticky p-0">
                      <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#primaryMenu"
                        aria-controls="primaryMenu"
                      >
                        <span className="navbar-toggler-icon" />
                      </button>
                      <a href="index.html" className="logo-link">
                        <img
                          className="logo logo-dark"
                          src="/assets/images/logos/logo-2.png"
                          alt="logo"
                        />
                        <img
                          className="logo logo-light"
                          src="/assets/images/logos/logo-2.png"
                          alt="logo"
                        />
                      </a>
                      <div
                        className="offcanvas offcanvas-collapse order-lg-2"
                        id="primaryMenu"
                      >
                        <div className="offcanvas-header navbar-shadow">
                          <h5 className="mt-1 mb-0">Menu</h5>
                          <button
                            className="btn-close lead"
                            type="button"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                          />
                        </div>
                        <div className="offcanvas-body">
                          {/* Menu*/}
                          <ul className="navbar-nav">
                            {/* Home */}
                            <li className="nav-item dropdown dropdown-mega">
                              <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                data-bs-toggle="dropdown"
                              >
                                Home
                              </a>
                              <div className="dropdown-menu home-menu">
                                <div className="row g-4">
                                  <div className="col-xl-2 mega-box">
                                    <a className="home-box" href="index.html">
                                      <img
                                        className="img-fluid"
                                        src="/assets/images/demo-img/demo1.jpg"
                                        alt="home1"
                                      />
                                      <span>Fashion Demo</span>
                                    </a>
                                  </div>
                                  <div className="col-xl-2 mega-box">
                                    <a className="home-box" href="index-2.html">
                                      <img
                                        className="img-fluid"
                                        src="/assets/images/demo-img/demo2.jpg"
                                        alt="home2"
                                      />
                                      <span>Bag Demo</span>
                                    </a>
                                  </div>
                                  <div className="col-xl-2 mega-box">
                                    <a className="home-box" href="index-3.html">
                                      <img
                                        className="img-fluid"
                                        src="/assets/images/demo-img/demo3.jpg"
                                        alt="home3"
                                      />
                                      <span>Grocery Demo</span>
                                    </a>
                                  </div>
                                  <div className="col-xl-2 mega-box">
                                    <a className="home-box" href="index-4.html">
                                      <img
                                        className="img-fluid"
                                        src="/assets/images/demo-img/demo4.jpg"
                                        alt="home4"
                                      />
                                      <span>Furniture Demo</span>
                                    </a>
                                  </div>
                                  <div className="col-xl-2 mega-box">
                                    <a className="home-box" href="index-5.html">
                                      <img
                                        className="img-fluid"
                                        src="/assets/images/demo-img/demo5.jpg"
                                        alt="home5"
                                      />
                                      <span>Watch Demo</span>
                                    </a>
                                  </div>
                                  <div className="col-xl-2 mega-box">
                                    <a className="home-box" href="index-6.html">
                                      <img
                                        className="img-fluid"
                                        src="/assets/images/demo-img/demo6.jpg"
                                        alt="home6"
                                      />
                                      <span>Shoes Demo</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </li>
                            {/* Shop */}
                            <li className="nav-item dropdown">
                              <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                data-bs-toggle="dropdown"
                              >
                                Shop
                              </a>
                              <div className="dropdown-menu">
                                <div className="dropdown-column">
                                  <a
                                    className="dropdown-item"
                                    href="shop-categories.html"
                                  >
                                    Shop Categories
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="shop-filter.html"
                                  >
                                    Shop Filter
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="shop-left-sidebar.html"
                                  >
                                    Shop Left Sidebar
                                  </a>
                                  <a className="dropdown-item" href="shop-list.html">
                                    Shop List
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="shop-masanory.html"
                                  >
                                    Shop Masonry
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="shop-no-sidebar.html"
                                  >
                                    Shop No Sidebar
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="shop-right-sidebar.html"
                                  >
                                    Shop Right Sidebar
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="shop-top-filter.html"
                                  >
                                    Shop Top Filter
                                  </a>
                                </div>
                              </div>
                            </li>
                            {/* Product */}
                            <li className="nav-item dropdown">
                              <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                data-bs-toggle="dropdown"
                              >
                                Product
                              </a>
                              <div className="dropdown-menu">
                                <div className="dropdown-column">
                                  <a
                                    className="dropdown-item"
                                    href="product-four-image.html"
                                  >
                                    Product 4 Images
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="product-slider.html"
                                  >
                                    Product Slider{" "}
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="product-sticky.html"
                                  >
                                    Product Sticky
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="product-three-column.html"
                                  >
                                    Product 3 Column
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="product-video-img.html"
                                  >
                                    Product Video
                                  </a>
                                  <a className="dropdown-item" href="product.html">
                                    Product Simple
                                  </a>
                                </div>
                              </div>
                            </li>
                            {/* Oslo Plus */}
                            <li className="nav-item dropdown dropdown-mega">
                              <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                data-bs-toggle="dropdown"
                              >
                                Oslo Plus
                              </a>
                              <div className="dropdown-menu mega-element-menu">
                                <div className="row g-4">
                                  <div className="col-xl-3">
                                    <div className="link-box">
                                      <h5>Portfolio Pages</h5>
                                      <div className="dropdown-column">
                                        <a
                                          className="dropdown-item"
                                          href="portfolio-2-grid.html"
                                        >
                                          Portfolio 2 Grid
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="portfolio-2-grid-masonry.html"
                                        >
                                          Portfolio 2 Grid Masonry
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="portfolio-3-grid.html"
                                        >
                                          Portfolio 3 Grid{" "}
                                          <span className="badge bg-theme-theme">
                                            Hot
                                          </span>
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="portfolio-3-grid-masonry.html"
                                        >
                                          Portfolio 3 Grid Masonry
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="portfolio-4-grid.html"
                                        >
                                          Portfolio 4 Grid
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="portfolio-4-grid-masonry.html"
                                        >
                                          Portfolio 4 Grid Masonry
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="portfolio-no-space-masonry.html"
                                        >
                                          Portfolio No Space Masonry
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-3">
                                    <div className="link-box">
                                      <h5>Elements Pages</h5>
                                      <div className="dropdown-column">
                                        <a
                                          className="dropdown-item"
                                          href="banner-element.html"
                                        >
                                          Banner Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="brand-element.html"
                                        >
                                          Brand Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="button-element.html"
                                        >
                                          Button Element{" "}
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="categories-element.html"
                                        >
                                          Categories Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="collection-banner-element.html"
                                        >
                                          Collection Banner Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="home-element.html"
                                        >
                                          Home Banner Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="instagram-element.html"
                                        >
                                          Instagram Element{" "}
                                          <span className="badge bg-theme-sun2">
                                            New
                                          </span>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-3">
                                    <div className="link-box">
                                      <h5>Elements Pages</h5>
                                      <div className="dropdown-column">
                                        <a
                                          className="dropdown-item"
                                          href="offer-banner-element.html"
                                        >
                                          Offer Banner Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="brand-element.html"
                                        >
                                          Brand Element{" "}
                                          <span className="badge bg-theme-theme">
                                            Hot
                                          </span>
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="product-card-element.html"
                                        >
                                          Product Card Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="seller-element.html"
                                        >
                                          Seller Section Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="service-element.html"
                                        >
                                          Service Section Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="tabs-element.html"
                                        >
                                          Tabs Element
                                        </a>
                                        <a
                                          className="dropdown-item"
                                          href="title-element.html"
                                        >
                                          Title Element
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xl-3 d-none d-xl-block">
                                    <div className="link-box">
                                      <div className="menu-img">
                                        <img
                                          className="img-fluid"
                                          src="/assets/images/demo-img/menu-bg.jpg"
                                          alt="img"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            {/* Pages */}
                            <li className="nav-item dropdown">
                              <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                data-bs-toggle="dropdown"
                              >
                                Pages
                              </a>
                              <div className="dropdown-menu">
                                <div className="dropdown-column">
                                  <a className="dropdown-item" href="404.html">
                                    404
                                  </a>
                                  <a className="dropdown-item" href="about-us.html">
                                    About Us{" "}
                                  </a>
                                  <a className="dropdown-item" href="address.html">
                                    Address
                                  </a>
                                  <a className="dropdown-item" href="cart.html">
                                    Cart
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="coming-soon.html"
                                  >
                                    Coming Soon
                                  </a>
                                  <a className="dropdown-item" href="compare.html">
                                    Compare
                                  </a>
                                  <a className="dropdown-item" href="contact-us.html">
                                    Contact Us
                                  </a>
                                  <a className="dropdown-item" href="faqs.html">
                                    Faqs
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="forgot-password.html"
                                  >
                                    Forgot Password
                                  </a>
                                  <a className="dropdown-item" href="login.html">
                                    Login
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="order-success.html"
                                  >
                                    Order Success
                                  </a>
                                  <a className="dropdown-item" href="otp.html">
                                    Otp
                                  </a>
                                  <a className="dropdown-item" href="payment.html">
                                    Payment
                                  </a>
                                  <a className="dropdown-item" href="register.html">
                                    Register
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="reset-password.html"
                                  >
                                    Reset Password
                                  </a>
                                  <a className="dropdown-item" href="search.html">
                                    Search
                                  </a>
                                  <a
                                    className="dropdown-item"
                                    href="user-dashboard.html"
                                  >
                                    User Dashboard
                                  </a>
                                  <a className="dropdown-item" href="wishlist.html">
                                    Wishlist
                                  </a>
                                </div>
                              </div>
                            </li>
                            {/* Blog */}
                            <li className="nav-item dropdown">
                              <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                data-bs-toggle="dropdown"
                              >
                                Blog
                              </a>
                              <div className="dropdown-menu">
                                <div className="dropdown-column">
                                  <a
                                    className="dropdown-item"
                                    href="blog-detail.html"
                                  >
                                    Blog Details
                                  </a>
                                  <a className="dropdown-item" href="blog-grid.html">
                                    Blog Grid{" "}
                                  </a>
                                  <a className="dropdown-item" href="blog-list.html">
                                    Blog List
                                  </a>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
              {/* Navigation End */}
              {/* Menu Right Start  */}
              <div className="menu-right">
                {/* Icon Menu Start */}
                <ul className="icon-menu">
                  <li>
                    <button className="search-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </button>
                    {/* Search Input Start */}
                    <div className="search-full bg-theme-bk-l">
                      <div className="input-group">
                        <span className="input-group-text">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-search"
                          >
                            <circle cx={11} cy={11} r={8} />
                            <line x1={21} y1={21} x2="16.65" y2="16.65" />
                          </svg>
                        </span>
                        <input
                          type="text"
                          className="form-control search-type bg-theme-bk-l"
                          placeholder="Search here.."
                        />
                        <span className="input-group-text close-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-x"
                          >
                            <line x1={18} y1={6} x2={6} y2={18} />
                            <line x1={6} y1={6} x2={18} y2={18} />
                          </svg>
                        </span>
                      </div>
                      {/* Suggestion Start */}
                      <div className="search-suggestion">
                        <ul>
                          <li>
                            <div className="product-cart media">
                              <img
                                src="/assets/images/fashion/product/front/4.jpg"
                                className="img-fluid blur-up lazyload"
                                alt=""
                              />
                              <div className="media-body">
                                <a href="javascript:void(0)">
                                  <h6>Women’s long sleeve Jacket</h6>
                                </a>
                                <ul className="rating p-0 mb">
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star fill"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star fill"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star fill"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star fill"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                </ul>
                                <p className="mb-0 mt-1">$280.00</p>
                              </div>
                            </div>
                          </li>
                          <li>
                            <div className="product-cart media">
                              <img
                                src="/assets/images/fashion/product/front/5.jpg"
                                className="img-fluid blur-up lazyload"
                                alt=""
                              />
                              <div className="media-body">
                                <a href="javascript:void(0)">
                                  <h6>Shirt short mini dresses</h6>
                                </a>
                                <ul className="rating p-0">
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star fill"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star fill"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star fill"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star fill"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                  <li>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-star"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                  </li>
                                </ul>
                                <p className="mb-0 mt-1">$35.00</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      {/* Suggestion Start */}
                    </div>
                    {/* Search Input End */}
                  </li>
                  <li className="user">
                    <div className="dropdown user-dropdown">
                      <a href="javascript:void(0)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-user"
                        >
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                          <circle cx={12} cy={7} r={4} />
                        </svg>
                      </a>
                      <ul className="onhover-show-div">
                        <li>
                          <a href="login.html">Login</a>
                        </li>
                        <li>
                          <a href="register.html">Register</a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div className="dropdown whislist-dropdown">
                      <a href="javascript:void(0)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-heart"
                        >
                          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                        </svg>{" "}
                        <span className="notification-label">0</span>
                      </a>
                      <div className="onhover-show-div">
                        <a href="wishlist.html">
                          {" "}
                          <img
                            src="https://themes.pixelstrap.com/oslo/assets/icons/svg/box.svg"
                            className="img-fluid"
                            alt="box"
                          />{" "}
                        </a>
                        <div className="content">
                          <a href="wishlist.html">
                            <h6>Your wishlist empty !!</h6>
                            <p>explore more and shortlist items.</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  {/* Cart Menu Start */}
                  <li>
                    <div className="dropdown shopingbag">
                      <a href="javascript:void(0)" className="cart-button">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-shopping-bag"
                        >
                          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                          <line x1={3} y1={6} x2={21} y2={6} />
                          <path d="M16 10a4 4 0 0 1-8 0" />
                        </svg>{" "}
                        <span className="notification-label">3</span>
                      </a>
                      <a
                        href="javascript:void(0)"
                        className="overlay-cart overlay-common"
                      />
                      <div className="onhover-cart-dropdown">
                        <div className="onhover-show-div">
                          <div className="dropdown-header">
                            <div className="control">
                              <a href="cart.html">Shopping Cart</a>
                              <button className="back-cart">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-arrow-right"
                                >
                                  <line x1={5} y1={12} x2={19} y2={12} />
                                  <polyline points="12 5 19 12 12 19" />
                                </svg>
                              </button>
                            </div>
                          </div>
                          <div className="card-wrap custom-scroll">
                            {/* Cart Item Start */}
                            <div className="cart-card media">
                              <a href="product.html">
                                {" "}
                                <img
                                  src="/assets/images/fashion/product/front/8.jpg"
                                  className="img-fluid"
                                  alt="product"
                                />{" "}
                              </a>
                              <div className="media-body">
                                <a href="product.html">
                                  {" "}
                                  <h6>Concrete Jungle Pack</h6>
                                </a>
                                <span>$120.00</span>
                                <div className="plus-minus">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-minus sub"
                                  >
                                    <line x1={5} y1={12} x2={19} y2={12} />
                                  </svg>
                                  <input
                                    type="number"
                                    defaultValue={1}
                                    min={1}
                                    max={10}
                                  />
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-plus add"
                                  >
                                    <line x1={12} y1={5} x2={12} y2={19} />
                                    <line x1={5} y1={12} x2={19} y2={12} />
                                  </svg>
                                </div>
                              </div>
                              <button className="remove-cart">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-x"
                                >
                                  <line x1={18} y1={6} x2={6} y2={18} />
                                  <line x1={6} y1={6} x2={18} y2={18} />
                                </svg>
                              </button>
                            </div>
                            {/* Cart Item End */}
                            {/* Cart Item Start */}
                            <div className="cart-card media">
                              <a href="product.html">
                                {" "}
                                <img
                                  src="/assets/images/fashion/product/front/9.jpg"
                                  className="img-fluid"
                                  alt="product"
                                />{" "}
                              </a>
                              <div className="media-body">
                                <a href="product.html">
                                  {" "}
                                  <h6>Concrete Jungle Pack</h6>
                                </a>
                                <span>$120.00</span>
                                <div className="plus-minus">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-minus sub"
                                  >
                                    <line x1={5} y1={12} x2={19} y2={12} />
                                  </svg>
                                  <input
                                    type="number"
                                    defaultValue={1}
                                    min={1}
                                    max={10}
                                  />
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-plus add"
                                  >
                                    <line x1={12} y1={5} x2={12} y2={19} />
                                    <line x1={5} y1={12} x2={19} y2={12} />
                                  </svg>
                                </div>
                              </div>
                              <button className="remove-cart">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-x"
                                >
                                  <line x1={18} y1={6} x2={6} y2={18} />
                                  <line x1={6} y1={6} x2={18} y2={18} />
                                </svg>
                              </button>
                            </div>
                            {/* Cart Item End */}
                            {/* Cart Item Start */}
                            <div className="cart-card media">
                              <a href="product.html">
                                {" "}
                                <img
                                  src="/assets/images/fashion/product/front/7.jpg"
                                  className="img-fluid"
                                  alt="product"
                                />{" "}
                              </a>
                              <div className="media-body">
                                <a href="product.html">
                                  {" "}
                                  <h6>Concrete Jungle Pack</h6>
                                </a>
                                <span>$120.00</span>
                                <div className="plus-minus">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-minus sub"
                                  >
                                    <line x1={5} y1={12} x2={19} y2={12} />
                                  </svg>
                                  <input
                                    type="number"
                                    defaultValue={1}
                                    min={1}
                                    max={10}
                                  />
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-plus add"
                                  >
                                    <line x1={12} y1={5} x2={12} y2={19} />
                                    <line x1={5} y1={12} x2={19} y2={12} />
                                  </svg>
                                </div>
                              </div>
                              <button className="remove-cart">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-x"
                                >
                                  <line x1={18} y1={6} x2={6} y2={18} />
                                  <line x1={6} y1={6} x2={18} y2={18} />
                                </svg>
                              </button>
                            </div>
                            {/* Cart Item End */}
                          </div>
                          <div className="dropdown-footer">
                            <div className="freedelevery">
                              <p className="terms-condition">
                                FREE SHIPPING! Continue Shopping to add more product
                                to you cart and receive free shipping for orders over{" "}
                                <strong>$500</strong>
                              </p>
                              <div className="progress">
                                <div
                                  className="progress-bar"
                                  role="progressbar"
                                  style={{ width: "70%" }}
                                  aria-valuenow={25}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                >
                                  70%
                                </div>
                              </div>
                            </div>
                            <div className="total-price">
                              <span>Total</span>
                              <span>$450</span>
                            </div>
                            <div className="btn-group block-group">
                              <a href="cart.html" className="btn-solid">
                                View Cart
                              </a>
                              <a href="payment.html" className="btn-outline">
                                Checkout
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  {/* Cart Menu End */}
                </ul>
                {/* Icon Menu End */}
              </div>
              {/* Menu Right End  */}
            </div>
          </div>
        </header>
        {/* Header End */}
        {/* Main Start */}
        <main className="main">
          {/* Home Banner Section Start */}
          <section className="home-slider-common home-slider2 ratio_40 p-0">
            <div className="swiper home-slider swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
              <div
                className="swiper-wrapper"
                id="swiper-wrapper-60cfc5730b653db4"
                aria-live="polite"
                style={{
                  transform: "translate3d(-1349px, 0px, 0px)",
                  transitionDuration: "0ms"
                }}
              >
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-prev"
                  data-swiper-slide-index={2}
                  role="group"
                  aria-label="3 / 3"
                  style={{ width: 1349 }}
                >
                  <div className="banner">
                    <div
                      className="bg-size"
                      style={{
                        backgroundImage:
                          "url(https://themes.pixelstrap.com/oslo/assets/images/bag/banner/banner1.jpg)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        display: "block"
                      }}
                    >
                      <img
                        className="bg-img img-fluid"
                        src="/assets/images/bag/banner/banner1.jpg"
                        alt="banner"
                        style={{ display: "none" }}
                      />
                    </div>
                    {/* Banner Image Left */}
                    <img
                      className="img-fluid banner-left-img d-none d-sm-block"
                      src="/assets/images/bag/slide/banner1-1.png"
                      alt="banner"
                    />
                    {/* Content Box */}
                    <div className="content-box">
                      <h1 className="heading">
                        Explore shop with <span> Trendy Collection</span>
                      </h1>
                      <p className="d-none d-xl-block">
                        Contemporary pure silk pocket square sophistication luxurious
                        coral print pocket pattern On trend inspired shades.
                      </p>
                      <a href="shop-left-sidebar.html" className="btn-style2">
                        ORDER NOW
                      </a>
                    </div>
                    {/* Banner Image Right */}
                    <img
                      className="img-fluid banner-right-img"
                      src="/assets/images/bag/slide/banner1-2.png"
                      alt="banner"
                    />
                  </div>
                </div>
                {/* Slide Start */}
                <div
                  className="swiper-slide swiper-slide-active"
                  data-swiper-slide-index={0}
                  role="group"
                  aria-label="1 / 3"
                  style={{ width: 1349 }}
                >
                  <div className="banner">
                    <div
                      className="bg-size"
                      style={{
                        backgroundImage:
                          "url(https://themes.pixelstrap.com/oslo/assets/images/bag/banner/banner1.jpg)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        display: "block"
                      }}
                    >
                      <img
                        className="bg-img img-fluid"
                        src="/assets/images/bag/banner/banner1.jpg"
                        alt="banner"
                        style={{ display: "none" }}
                      />
                    </div>
                    {/* Banner Image Left */}
                    <img
                      className="img-fluid banner-left-img d-none d-sm-block"
                      src="/assets/images/bag/slide/banner1-1.png"
                      alt="banner"
                    />
                    {/* Content Box */}
                    <div className="content-box">
                      <h1 className="heading">
                        Explore shop with <span> Trendy Collection</span>
                      </h1>
                      <p className="d-none d-xl-block">
                        Contemporary pure silk pocket square sophistication luxurious
                        coral print pocket pattern on trend inspired shades.
                      </p>
                      <a href="shop-left-sidebar.html" className="btn-style2">
                        ORDER NOW
                      </a>
                    </div>
                    {/* Banner Image Right */}
                    <img
                      className="img-fluid banner-right-img"
                      src="/assets/images/bag/slide/banner1-2.png"
                      alt="banner"
                    />
                  </div>
                </div>
                {/* Slide End */}
                {/* Slide Start */}
                <div
                  className="swiper-slide swiper-slide-next"
                  data-swiper-slide-index={1}
                  role="group"
                  aria-label="2 / 3"
                  style={{ width: 1349 }}
                >
                  <div className="banner">
                    <div
                      className="bg-size"
                      style={{
                        backgroundImage:
                          "url(https://themes.pixelstrap.com/oslo/assets/images/bag/banner/banner1.jpg)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        display: "block"
                      }}
                    >
                      <img
                        className="bg-img img-fluid"
                        src="/assets/images/bag/banner/banner1.jpg"
                        alt="banner"
                        style={{ display: "none" }}
                      />
                    </div>
                    {/* Banner Image Left */}
                    <img
                      className="img-fluid banner-left-img d-none d-sm-block"
                      src="/assets/images/bag/slide/banner1-1.png"
                      alt="banner"
                    />
                    {/* Content Box */}
                    <div className="content-box">
                      <h1 className="heading">
                        Explore shop with <span> Trendy Collection</span>
                      </h1>
                      <p className="d-none d-xl-block">
                        Contemporary pure silk pocket square sophistication luxurious
                        coral print pocket pattern On trend inspired shades.
                      </p>
                      <a href="shop-left-sidebar.html" className="btn-style2">
                        ORDER NOW
                      </a>
                    </div>
                    {/* Banner Image Right */}
                    <img
                      className="img-fluid banner-right-img"
                      src="/assets/images/bag/slide/banner1-2.png"
                      alt="banner"
                    />
                  </div>
                </div>
                {/* Slide End */}
                {/* Slide Start */}
                <div
                  className="swiper-slide swiper-slide-duplicate-prev"
                  data-swiper-slide-index={2}
                  role="group"
                  aria-label="3 / 3"
                  style={{ width: 1349 }}
                >
                  <div className="banner">
                    <div
                      className="bg-size"
                      style={{
                        backgroundImage:
                          "url(https://themes.pixelstrap.com/oslo/assets/images/bag/banner/banner1.jpg)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        display: "block"
                      }}
                    >
                      <img
                        className="bg-img img-fluid"
                        src="/assets/images/bag/banner/banner1.jpg"
                        alt="banner"
                        style={{ display: "none" }}
                      />
                    </div>
                    {/* Banner Image Left */}
                    <img
                      className="img-fluid banner-left-img d-none d-sm-block"
                      src="/assets/images/bag/slide/banner1-1.png"
                      alt="banner"
                    />
                    {/* Content Box */}
                    <div className="content-box">
                      <h1 className="heading">
                        Explore shop with <span> Trendy Collection</span>
                      </h1>
                      <p className="d-none d-xl-block">
                        Contemporary pure silk pocket square sophistication luxurious
                        coral print pocket pattern On trend inspired shades.
                      </p>
                      <a href="shop-left-sidebar.html" className="btn-style2">
                        ORDER NOW
                      </a>
                    </div>
                    {/* Banner Image Right */}
                    <img
                      className="img-fluid banner-right-img"
                      src="/assets/images/bag/slide/banner1-2.png"
                      alt="banner"
                    />
                  </div>
                </div>
                {/* Slide End */}
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                  data-swiper-slide-index={0}
                  role="group"
                  aria-label="1 / 3"
                  style={{ width: 1349 }}
                >
                  <div className="banner">
                    <div
                      className="bg-size"
                      style={{
                        backgroundImage:
                          "url(https://themes.pixelstrap.com/oslo/assets/images/bag/banner/banner1.jpg)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        display: "block"
                      }}
                    >
                      <img
                        className="bg-img img-fluid"
                        src="/assets/images/bag/banner/banner1.jpg"
                        alt="banner"
                        style={{ display: "none" }}
                      />
                    </div>
                    {/* Banner Image Left */}
                    <img
                      className="img-fluid banner-left-img d-none d-sm-block"
                      src="/assets/images/bag/slide/banner1-1.png"
                      alt="banner"
                    />
                    {/* Content Box */}
                    <div className="content-box">
                      <h1 className="heading">
                        Explore shop with <span> Trendy Collection</span>
                      </h1>
                      <p className="d-none d-xl-block">
                        Contemporary pure silk pocket square sophistication luxurious
                        coral print pocket pattern on trend inspired shades.
                      </p>
                      <a href="shop-left-sidebar.html" className="btn-style2">
                        ORDER NOW
                      </a>
                    </div>
                    {/* Banner Image Right */}
                    <img
                      className="img-fluid banner-right-img"
                      src="/assets/images/bag/slide/banner1-2.png"
                      alt="banner"
                    />
                  </div>
                </div>
              </div>
              <div className="swiper-pagination small swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                <span
                  className="swiper-pagination-bullet swiper-pagination-bullet-active"
                  tabIndex={0}
                  role="button"
                  aria-label="Go to slide 1"
                  aria-current="true"
                />
                <span
                  className="swiper-pagination-bullet"
                  tabIndex={0}
                  role="button"
                  aria-label="Go to slide 2"
                />
                <span
                  className="swiper-pagination-bullet"
                  tabIndex={0}
                  role="button"
                  aria-label="Go to slide 3"
                />
              </div>
              <span
                className="swiper-notification"
                aria-live="assertive"
                aria-atomic="true"
              />
            </div>
          </section>
          {/* Home Banner Section End */}
          {/* Categories Section Start */}
          <div className="catagories-section catagories-style-2">
            <div className="swiper home-catagories-2 swiper-initialized swiper-horizontal swiper-pointer-events">
              <div
                className="swiper-wrapper"
                id="swiper-wrapper-147950bfe3f87b81"
                aria-live="polite"
                style={{
                  transform: "translate3d(-1349px, 0px, 0px)",
                  transitionDuration: "0ms"
                }}
              >
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                  data-swiper-slide-index={1}
                  role="group"
                  aria-label="2 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand2.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={2}
                  role="group"
                  aria-label="3 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand3.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={3}
                  role="group"
                  aria-label="4 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand4.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={4}
                  role="group"
                  aria-label="5 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand5.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={5}
                  role="group"
                  aria-label="6 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand6.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-prev"
                  data-swiper-slide-index={6}
                  role="group"
                  aria-label="7 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand3.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-active"
                  data-swiper-slide-index={0}
                  role="group"
                  aria-label="1 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand1.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-next"
                  data-swiper-slide-index={1}
                  role="group"
                  aria-label="2 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand2.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide"
                  data-swiper-slide-index={2}
                  role="group"
                  aria-label="3 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand3.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide"
                  data-swiper-slide-index={3}
                  role="group"
                  aria-label="4 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand4.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide"
                  data-swiper-slide-index={4}
                  role="group"
                  aria-label="5 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand5.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide"
                  data-swiper-slide-index={5}
                  role="group"
                  aria-label="6 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand6.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate-prev"
                  data-swiper-slide-index={6}
                  role="group"
                  aria-label="7 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand3.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                  data-swiper-slide-index={0}
                  role="group"
                  aria-label="1 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand1.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                  data-swiper-slide-index={1}
                  role="group"
                  aria-label="2 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand2.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={2}
                  role="group"
                  aria-label="3 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand3.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={3}
                  role="group"
                  aria-label="4 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand4.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={4}
                  role="group"
                  aria-label="5 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand5.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={5}
                  role="group"
                  aria-label="6 / 7"
                  style={{ width: "224.833px" }}
                >
                  <div className="catagories">
                    <a href="shop-left-sidebar.html">
                      <div className="img-wrap">
                        <img
                          src="/assets/images/bag/brand/brand6.png"
                          alt="jeans"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <span
                className="swiper-notification"
                aria-live="assertive"
                aria-atomic="true"
              />
            </div>
          </div>
          {/* Categories Section End */}
          {/* Offer Section Start */}
          <section className="offer-section pb-0">
            <div className="container-lg">
              <div className="row g-4 g-lg-6">
                <div className="col-6 col-sm-3">
                  <div className="offer">
                    <h5 className="offer-heading">
                      GET 20% OFF
                      <span className="bg-theme-pink" />
                    </h5>
                    <p>ON ORDERS OVER $20*</p>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="offer">
                    <h5 className="offer-heading">
                      GET 23% OFF
                      <span className="bg-theme-yellow" />
                    </h5>
                    <p>ON ORDERS OVER $50*</p>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="offer">
                    <h5 className="offer-heading">
                      GET 47% OFF
                      <span className="bg-theme-orange" />
                    </h5>
                    <p>ON ORDERS OVER $99*</p>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="offer">
                    <h5 className="offer-heading">
                      Code : CODE09
                      <span className="bg-theme-blue" />
                    </h5>
                    <p>Apply Code and get Discount</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Offer Section End */}
          {/* Top Product Section Start */}
          <section className="pb-0">
            <div className="container-lg">
              {/* Tabs Start */}
              <div className="nav-tabs-star">
                {/* Tabs Filter Start */}
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="skirts-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#skirts"
                      type="button"
                      role="tab"
                      aria-controls="skirts"
                      aria-selected="true"
                    >
                      SKIRTS
                    </button>
                  </li>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-star"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="short-bag-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#short-bag"
                      type="button"
                      role="tab"
                      aria-controls="short-bag"
                      aria-selected="false"
                    >
                      SPORT BAGS
                    </button>
                  </li>
                  <li>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-star"
                    >
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="women-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#women"
                      type="button"
                      role="tab"
                      aria-controls="women"
                      aria-selected="false"
                    >
                      WOMEN
                    </button>
                  </li>
                </ul>
                {/* Tabs Filter End */}
                {/* Tab Content Start */}
                <div
                  className="tab-content ratio_asos wow fadeInUp"
                  data-wow-delay="0.4s"
                  id="pills-tabContent"
                  style={{
                    visibility: "visible",
                    animationDelay: "0.4s",
                    animationName: "fadeInUp"
                  }}
                >
                  {/* Skirts Tab Content Start */}
                  <div
                    className="tab-pane fade show active"
                    id="skirts"
                    role="tabpanel"
                    aria-labelledby="skirts-tab"
                  >
                    <div className="swiper product-slider swiper-initialized swiper-horizontal swiper-pointer-events">
                      <div
                        className="swiper-wrapper"
                        id="swiper-wrapper-63c22d62e72af16c"
                        aria-live="polite"
                        style={{
                          transform: "translate3d(-1131px, 0px, 0px)",
                          transitionDuration: "0ms"
                        }}
                      >
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                          data-swiper-slide-index={0}
                          role="group"
                          aria-label="1 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                          data-swiper-slide-index={1}
                          role="group"
                          aria-label="2 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={2}
                          role="group"
                          aria-label="3 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={3}
                          role="group"
                          aria-label="4 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-prev"
                          data-swiper-slide-index={4}
                          role="group"
                          aria-label="5 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-active"
                          data-swiper-slide-index={0}
                          role="group"
                          aria-label="1 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-next"
                          data-swiper-slide-index={1}
                          role="group"
                          aria-label="2 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          data-swiper-slide-index={2}
                          role="group"
                          aria-label="3 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                  className=""
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                  className=""
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                  className=""
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                  className=""
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide"
                          data-swiper-slide-index={3}
                          role="group"
                          aria-label="4 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate-prev"
                          data-swiper-slide-index={4}
                          role="group"
                          aria-label="5 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                          data-swiper-slide-index={0}
                          role="group"
                          aria-label="1 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                          data-swiper-slide-index={1}
                          role="group"
                          aria-label="2 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={2}
                          role="group"
                          aria-label="3 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={3}
                          role="group"
                          aria-label="4 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={4}
                          role="group"
                          aria-label="5 / 5"
                          style={{ width: "211.2px", marginRight: 15 }}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span
                        className="swiper-notification"
                        aria-live="assertive"
                        aria-atomic="true"
                      />
                    </div>
                  </div>
                  {/* Skirts Tab Content End */}
                  {/* Short Bag Tab Content Start */}
                  <div
                    className="tab-pane fade"
                    id="short-bag"
                    role="tabpanel"
                    aria-labelledby="short-bag-tab"
                  >
                    <div className="swiper product-slider swiper-initialized swiper-horizontal swiper-pointer-events">
                      <div
                        className="swiper-wrapper"
                        id="swiper-wrapper-37a5b94fc59a3616"
                        aria-live="polite"
                        style={{ transitionDuration: "0ms" }}
                      >
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                          data-swiper-slide-index={0}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={1}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={2}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={3}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={4}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={0}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={1}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={2}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={3}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={4}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                          data-swiper-slide-index={0}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={1}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={2}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={3}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={4}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span
                        className="swiper-notification"
                        aria-live="assertive"
                        aria-atomic="true"
                      />
                    </div>
                  </div>
                  {/* Short Bag Tab Content End */}
                  {/* Women Tab Content Start */}
                  <div
                    className="tab-pane fade"
                    id="women"
                    role="tabpanel"
                    aria-labelledby="women-tab"
                  >
                    <div className="swiper product-slider swiper-initialized swiper-horizontal swiper-pointer-events">
                      <div
                        className="swiper-wrapper"
                        id="swiper-wrapper-166307dc10f4cf147"
                        aria-live="polite"
                        style={{ transitionDuration: "0ms" }}
                      >
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                          data-swiper-slide-index={0}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={1}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={2}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={3}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={4}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={0}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={1}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={2}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={3}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="swiper-slide" data-swiper-slide-index={4}>
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                          data-swiper-slide-index={0}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/2.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>165</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Baggit</p>
                                <h5>luxury fashion Brown handbag</h5>
                                <span>$120.00</span>
                                <del>$150.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={1}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/1.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>245</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Legal Bribe</p>
                                <h5>Off-Brown Quilted Handheld Bag</h5>
                                <span>$140.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={2}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/3.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  {" "}
                                  NEW
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>215</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Lino Perros</p>
                                <h5>Parrot Solid Hobo Bag</h5>
                                <span>$100.00</span> <del>$140.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={3}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/4.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/4.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>136</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Red-handbag</h5>
                                <span>$120.00</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="swiper-slide swiper-slide-duplicate"
                          data-swiper-slide-index={4}
                        >
                          <div className="product-card">
                            <div className="img-box">
                              {/* Thumbnail */}
                              <ul className="thumbnail-img">
                                <li className="active thumb">
                                  <img
                                    src="/assets/images/bag/product/3-1.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-2.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-3.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                                <li className="thumb">
                                  <img
                                    src="/assets/images/bag/product/3-4.jpg"
                                    alt="thumbnail"
                                  />
                                </li>
                              </ul>
                              <a
                                href="product.html"
                                className="primary-img bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/5.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="img-fluid bg-img"
                                  src="/assets/images/bag/product/5.jpg"
                                  alt="product"
                                  style={{ display: "none" }}
                                />{" "}
                              </a>
                              {/* Arrow label */}
                              <span className="arrow-label-wrap">
                                {" "}
                                <span className="arrow-label bg-theme-theme">
                                  SALE
                                </span>{" "}
                              </span>
                              {/* Rating */}
                              <div className="rating">
                                <span>
                                  4.5{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-star"
                                  >
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                  </svg>{" "}
                                </span>
                                <span>149</span>
                              </div>
                              {/* Option */}
                              <ul className="option-wrap">
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Wishlist"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="wishlist-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-heart"
                                    >
                                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="Compare"
                                >
                                  <a href="compare.html">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-repeat"
                                    >
                                      <polyline points="17 1 21 5 17 9" />
                                      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                      <polyline points="7 23 3 19 7 15" />
                                      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="View Product"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-eye"
                                    >
                                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                      <circle cx={12} cy={12} r={3} />
                                    </svg>
                                  </a>
                                </li>
                                <li
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="left"
                                  title=""
                                  data-bs-original-title="My Cart"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="addtocart-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-shopping-bag"
                                    >
                                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                      <line x1={3} y1={6} x2={21} y2={6} />
                                      <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            {/* Content Box */}
                            <div className="content-box">
                              <a href="product.html">
                                <p>Mast &amp; Harbour</p>
                                <h5>Blue Solid Handheld Bag</h5>
                                <span>$220.00</span> <del>$230.00</del>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span
                        className="swiper-notification"
                        aria-live="assertive"
                        aria-atomic="true"
                      />
                    </div>
                  </div>
                  {/* Women Tab Content End */}
                </div>
                {/* Tab Content End */}
              </div>
              {/* Tabs End */}
            </div>
          </section>
          {/* Top Product Section End */}
          {/* Special Product Section Start */}
          <section className="special-product special-product-2 pb-0">
            <div className="container-lg">
              <div className="title-box">
                <h2 className="unique-heading">SPECIAL PRODUCTS</h2>
                <span className="title-divider2">
                  <svg>
                    <use xlinkHref="/assets/icons/svg/_sprite.svg#shop-bag" />
                  </svg>
                </span>
                <p>
                  Unique design hand bag made my famous designers trending on social
                  events
                </p>
              </div>
              <div className="row g-2 g-xl-3">
                <div className="col-md-7">
                  <div className="row g-2 g-xl-3">
                    <div
                      className="col-sm-8 ratio2_3 wow fadeInUp"
                      data-wow-delay="0.1s"
                      style={{
                        visibility: "hidden",
                        animationDelay: "0.1s",
                        animationName: "none"
                      }}
                    >
                      <div className="product-box">
                        <a
                          href="shop-left-sidebar.html"
                          className="img-wrap bg-size"
                          style={{
                            backgroundImage:
                              "url(https://themes.pixelstrap.com/oslo/assets/images/bag/category/1.jpg)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            display: "block"
                          }}
                        >
                          <img
                            className="bg-img img-fluid"
                            src="/assets/images/bag/category/1.jpg"
                            alt="catagories"
                            style={{ display: "none" }}
                          />
                        </a>
                        <div className="catagories-small-label right-align">
                          <a href="shop-left-sidebar.html">
                            <h5>TOTE BAG</h5>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-6 col-sm-4 ratio_asos wow fadeInUp"
                      data-wow-delay="0.2s"
                      style={{
                        visibility: "hidden",
                        animationDelay: "0.2s",
                        animationName: "none"
                      }}
                    >
                      <div className="product-box">
                        <a
                          href="shop-left-sidebar.html"
                          className="img-wrap bg-size"
                          style={{
                            backgroundImage:
                              "url(https://themes.pixelstrap.com/oslo/assets/images/bag/category/2.jpg)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            display: "block"
                          }}
                        >
                          <img
                            className="bg-img img-fluid"
                            src="/assets/images/bag/category/2.jpg"
                            alt="catagories"
                            style={{ display: "none" }}
                          />
                        </a>
                        <div className="catagories-small-label">
                          <a href="shop-left-sidebar.html">
                            <h5>SHOULDER BAGS</h5>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-6 col-sm-4 ratio_asos wow fadeInUp"
                      data-wow-delay="0.3s"
                      style={{
                        visibility: "hidden",
                        animationDelay: "0.3s",
                        animationName: "none"
                      }}
                    >
                      <div className="product-box">
                        <a
                          href="shop-left-sidebar.html"
                          className="img-wrap bg-size"
                          style={{
                            backgroundImage:
                              "url(https://themes.pixelstrap.com/oslo/assets/images/bag/category/3.jpg)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            display: "block"
                          }}
                        >
                          <img
                            className="bg-img img-fluid"
                            src="/assets/images/bag/category/3.jpg"
                            alt="catagories"
                            style={{ display: "none" }}
                          />
                        </a>
                        <div className="catagories-small-label">
                          <a href="shop-left-sidebar.html">
                            <h5>BACKPACKS</h5>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-6 col-sm-4 ratio_asos wow fadeInUp"
                      data-wow-delay="0.4s"
                      style={{
                        visibility: "hidden",
                        animationDelay: "0.4s",
                        animationName: "none"
                      }}
                    >
                      <div className="product-box">
                        <a
                          href="shop-left-sidebar.html"
                          className="img-wrap bg-size"
                          style={{
                            backgroundImage:
                              "url(https://themes.pixelstrap.com/oslo/assets/images/bag/category/4.jpg)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            display: "block"
                          }}
                        >
                          <img
                            className="bg-img img-fluid"
                            src="/assets/images/bag/category/4.jpg"
                            alt="catagories"
                            style={{ display: "none" }}
                          />
                        </a>
                        <div className="catagories-small-label">
                          <a href="shop-left-sidebar.html">
                            <h5>LATHER BAG</h5>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-6 col-sm-4 ratio_asos wow fadeInUp"
                      data-wow-delay="0.5s"
                      style={{
                        visibility: "hidden",
                        animationDelay: "0.5s",
                        animationName: "none"
                      }}
                    >
                      <div className="product-box">
                        <a
                          href="shop-left-sidebar.html"
                          className="img-wrap bg-size"
                          style={{
                            backgroundImage:
                              "url(https://themes.pixelstrap.com/oslo/assets/images/bag/category/5.jpg)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            display: "block"
                          }}
                        >
                          <img
                            className="bg-img img-fluid"
                            src="/assets/images/bag/category/5.jpg"
                            alt="catagories"
                            style={{ display: "none" }}
                          />
                        </a>
                        <div className="catagories-small-label">
                          <a href="shop-left-sidebar.html">
                            <h5>OFFICE BAG</h5>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-5 ratio_115 wow fadeInUp"
                  data-wow-delay="0.6s"
                  style={{
                    visibility: "hidden",
                    animationDelay: "0.6s",
                    animationName: "none"
                  }}
                >
                  <div className="product-box">
                    <a
                      href="shop-left-sidebar.html"
                      className="img-wrap bg-size"
                      style={{
                        backgroundImage:
                          "url(https://themes.pixelstrap.com/oslo/assets/images/bag/category/6.jpg)",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        display: "block"
                      }}
                    >
                      <img
                        className="bg-img img-fluid"
                        src="/assets/images/bag/category/6.jpg"
                        alt="catagories"
                        style={{ display: "none" }}
                      />
                    </a>
                    <div className="catagories-large-label">
                      <a href="shop-left-sidebar.html">
                        <span className="title-color">Travel Bag</span>
                        <h3>GOING ON COLLECTION</h3>
                        <ul className="timer">
                          <li>
                            <span className="days time-value">-724</span>{" "}
                            <span className="timer-label">Days</span>
                          </li>
                          <li>
                            <span className="hours time-value">-14</span>{" "}
                            <span className="timer-label">Hours</span>
                          </li>
                          <li>
                            <span className="minutes time-value">-12</span>{" "}
                            <span className="timer-label">Minute</span>
                          </li>
                          <li>
                            <span className="seconds time-value">-41</span>{" "}
                            <span className="timer-label">Seconds</span>
                          </li>
                        </ul>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Special Product Section End */}
          {/* Sub Banner Section Start */}
          <div className="sub-banner sub-banner-2 section-t-space ratio_asos">
            <div
              className="sub-banner bg-size"
              style={{
                backgroundImage:
                  "url(https://themes.pixelstrap.com/oslo/assets/images/bag/banner/sub-banner.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "block"
              }}
            >
              <img
                className="bg-img img-fluid"
                src="/assets/images/bag/banner/sub-banner.jpg"
                alt="sub-banner"
                style={{ display: "none" }}
              />
              <div className="content-box">
                <div className="heading-wrap">
                  <span className="span-4">Super</span>
                  <span className="span-3">SALE</span>
                  <span className="offer-text">
                    Save Up To <strong>50%</strong> OFF
                  </span>
                </div>
                <a href="shop-left-sidebar.html" className="btn-style2">
                  SHOP NOW
                </a>
              </div>
            </div>
          </div>
          {/* Sub Banner Section End */}
          {/* Best Seller Start */}
          <section className="best-seller pb-0">
            <div className="container-lg">
              <div className="title-box">
                <h2 className="unique-heading">BEST SELLER</h2>
                <span className="title-divider2">
                  <svg>
                    <use xlinkHref="/assets/icons/svg/_sprite.svg#shop-bag" />
                  </svg>
                </span>
                <p>
                  The best ways to change your summer wardrobe into autumn wardrobe.
                </p>
              </div>
              <div
                className="row g-4 wow fadeInUp"
                data-wow-delay="0.6s"
                style={{
                  visibility: "hidden",
                  animationDelay: "0.6s",
                  animationName: "none"
                }}
              >
                <div className="col-xxl-4">
                  <div className="row g-3 g-xxl-4">
                    <div className="col-md-6 col-xxl-12">
                      <div className="product-card-side bg-theme-p-side-2">
                        <div className="img-wrap">
                          <a href="product.html">
                            <img
                              className="img-fluid"
                              src="/assets/images/bag/product/6.jpg"
                              alt="bag"
                            />
                          </a>
                        </div>
                        <div className="content-box mb-0">
                          <a href="product.html">
                            <p>Adidas</p>
                            <h5 className="truncate-2">
                              UTO Women Backpack Purse PU Washed
                            </h5>
                            <span>$100.00</span> <del>$140.00</del>
                          </a>
                          {/* Rating */}
                          <div className="rating">
                            <span>
                              4.5{" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-star"
                              >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                              </svg>{" "}
                            </span>
                            <span>165</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xxl-12">
                      <div className="product-card-side bg-theme-p-side-2">
                        <div className="img-wrap">
                          <a href="product.html">
                            <img
                              className="img-fluid"
                              src="/assets/images/bag/product/7.jpg"
                              alt="bag"
                            />
                          </a>
                        </div>
                        <div className="content-box mb-0">
                          <a href="product.html">
                            <p>Lino Perros</p>
                            <h5 className="truncate-2">
                              Back Bag For Woman/ School Bag
                            </h5>
                            <span>$120.00</span> <del>$200.00</del>
                          </a>
                          {/* Rating */}
                          <div className="rating">
                            <span>
                              4.5{" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-star"
                              >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                              </svg>{" "}
                            </span>
                            <span>238</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-8">
                  <div className="card-box row g-3 g-sm-4">
                    <div className="col-sm-6">
                      <div className="card-wrap">
                        <h5 className="title-line">
                          <span> New Arrival</span>
                        </h5>
                        <div className="product-card-side product-side2">
                          <div className="img-wrap">
                            <a href="product.html">
                              <img
                                className="img-fluid"
                                src="/assets/images/bag/product/png/1.png"
                                alt="bag"
                              />
                            </a>
                          </div>
                          <div className="content-box">
                            <a href="product.html">
                              <p>Buxton</p>
                              <h5 className="truncate-2">Women bag</h5>
                              <span>$130.00</span> <del>$200.00</del>
                            </a>
                          </div>
                        </div>
                        <div className="product-card-side product-side2">
                          <div className="img-wrap">
                            <a href="product.html">
                              <img
                                className="img-fluid"
                                src="/assets/images/bag/product/png/2.png"
                                alt="bag"
                              />
                            </a>
                          </div>
                          <div className="content-box">
                            <a href="product.html">
                              <p>Buxton</p>
                              <h5 className="truncate-2">
                                Color purple elegance Bag
                              </h5>
                              <span>$210.00</span>
                            </a>
                          </div>
                        </div>
                        <div className="product-card-side product-side2">
                          <div className="img-wrap">
                            <a href="product.html">
                              <img
                                className="img-fluid"
                                src="/assets/images/bag/product/png/3.png"
                                alt="bag"
                              />
                            </a>
                          </div>
                          <div className="content-box">
                            <a href="product.html">
                              <p>Baggit</p>
                              <h5 className="truncate-2">Handbag</h5>
                              <span>$220.00</span> <del>$250.00</del>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="card-wrap">
                        <h5 className="title-line">
                          <span>Featured </span>
                        </h5>
                        <div className="product-card-side product-side2">
                          <div className="img-wrap">
                            <a href="product.html">
                              <img
                                className="img-fluid"
                                src="/assets/images/bag/product/png/4.png"
                                alt="bag"
                              />
                            </a>
                          </div>
                          <div className="content-box">
                            <a href="product.html">
                              <p>Buxton</p>
                              <h5 className="truncate-2">
                                Sally Hansen Airbrush Legs
                              </h5>
                              <span>$140.00</span> <del>$180.00</del>
                            </a>
                          </div>
                        </div>
                        <div className="product-card-side product-side2">
                          <div className="img-wrap">
                            <a href="product.html">
                              <img
                                className="img-fluid"
                                src="/assets/images/bag/product/png/5.png"
                                alt="bag"
                              />
                            </a>
                          </div>
                          <div className="content-box">
                            <a href="product.html">
                              <p>Pez dorado</p>
                              <h5 className="truncate-2">
                                Beige Oversized Structured Handheld Bag
                              </h5>
                              <span>$210.00</span>
                            </a>
                          </div>
                        </div>
                        <div className="product-card-side product-side2">
                          <div className="img-wrap">
                            <a href="product.html">
                              <img
                                className="img-fluid"
                                src="/assets/images/bag/product/png/6.png"
                                alt="bag"
                              />
                            </a>
                          </div>
                          <div className="content-box">
                            <a href="product.html">
                              <p>Baggit</p>
                              <h5 className="truncate-2">Beige Solid Sling Bag</h5>
                              <span>$160.00</span> <del>$220.00</del>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Best Seller End */}
          {/* Brand We Love Section Start */}
          <section className="brand-section2 pb-0 wow-section-overflow">
            <div className="container-lg">
              <div className="title-box">
                <h2 className="unique-heading">BRAND WE LOVE</h2>
                <span className="title-divider2">
                  <svg>
                    <use xlinkHref="/assets/icons/svg/_sprite.svg#shop-bag" />
                  </svg>
                </span>
                <p>
                  Top Company brand are available, all are unique and different design
                  from each other
                </p>
              </div>
              <div className="row g-3 g-sm-0">
                <div className="col-12">
                  <div className="row g-0">
                    <div className="col-sm-6">
                      <img
                        className="img-fluid"
                        src="/assets/images/bag/brand-welove/2.jpg"
                        alt="product"
                      />
                    </div>
                    <div className="col-sm-6">
                      <div className="brand-details bg-theme-p-side-2">
                        <div>
                          <span className="theme-color">New From True Brand</span>
                          <h3>New In this Week Your style update</h3>
                          <p>
                            Every week there are new designed bag comes,here is many
                            designer prove theme self and give new design,this week
                            there are served new bag design introduce explore theme
                            all
                          </p>
                          <a href="shop-left-sidebar.html" className="btn-style2">
                            SHOP NOW
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row g-0">
                    <div className="order-4 order-sm-3 col-sm-6">
                      <div className="brand-details bg-theme-p-side-2">
                        <div>
                          <span className="theme-color">Get Set, Go!</span>
                          <h3>made by professionals for you</h3>
                          <p>
                            Many professionals designer are give there Creative idea
                            ,here are some of design are popular quickly to market for
                            there Unique design and creative ideas, here are there
                            collection for sell
                          </p>
                          <a href="shop-left-sidebar.html" className="btn-style2">
                            SHOP NOW
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="order-3 order-sm-4 col-sm-6">
                      <img
                        className="img-fluid"
                        src="/assets/images/bag/brand-welove/2.jpg"
                        alt="product"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Brand We Love Section end */}
          {/* Service Section start */}
          <section className="service-section pb-0">
            <div className="container-lg">
              <div className="row g-3 g-md-4 g-lg-0">
                <div className="col-6 col-lg-3">
                  <div className="service-box">
                    <div className="media">
                      <svg>
                        <use xlinkHref="/assets/icons/svg/service/_sprite.svg#truck" />
                      </svg>
                      <div className="media-body">
                        <h5>Free Shipping</h5>
                        <span>From all orders over $200</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-lg-3">
                  <div className="service-box">
                    <div className="media">
                      <svg>
                        <use xlinkHref="/assets/icons/svg/service/_sprite.svg#component" />
                      </svg>
                      <div className="media-body">
                        <h5>FREE RETURNS</h5>
                        <span>Return money within 30 days</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-lg-3">
                  <div className="service-box">
                    <div className="media">
                      <svg>
                        <use xlinkHref="/assets/icons/svg/service/_sprite.svg#dollar" />
                      </svg>
                      <div className="media-body">
                        <h5>SECURE SHOPPING</h5>
                        <span>You're in safe hands</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-lg-3">
                  <div className="service-box">
                    <div className="media">
                      <svg>
                        <use xlinkHref="/assets/icons/svg/service/_sprite.svg#thum" />
                      </svg>
                      <div className="media-body">
                        <h5>OVER 10,000 STYLES</h5>
                        <span>We have everything you need</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Service Section End */}
          {/* Instagram Section Start */}
          <section className="intagram-section">
            <div className="container-lg">
              <div className="title-box">
                <h2 className="unique-heading">AVONE ON INSTAGRAM</h2>
                <span className="title-divider2">
                  <svg>
                    <use xlinkHref="/assets/icons/svg/_sprite.svg#shop-bag" />
                  </svg>
                </span>
                <p>trending on Instagram best product value for mony</p>
              </div>
            </div>
            <div className="swiper instagram-slider ratio_94 swiper-initialized swiper-horizontal swiper-pointer-events">
              <div
                className="swiper-wrapper"
                id="swiper-wrapper-2d48ee95e1dca8a3"
                aria-live="polite"
                style={{
                  transform: "translate3d(-1367px, 0px, 0px)",
                  transitionDuration: "0ms"
                }}
              >
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                  data-swiper-slide-index={1}
                  role="group"
                  aria-label="2 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/2.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/2.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={2}
                  role="group"
                  aria-label="3 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/3.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/3.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={3}
                  role="group"
                  aria-label="4 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/4.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/4.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={4}
                  role="group"
                  aria-label="5 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/5.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/5.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-prev"
                  data-swiper-slide-index={5}
                  role="group"
                  aria-label="6 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/3.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/3.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Slide Start */}
                <div
                  className="swiper-slide swiper-slide-active"
                  data-swiper-slide-index={0}
                  role="group"
                  aria-label="1 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/1.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/1.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Slide End */}
                {/* Slide Start */}
                <div
                  className="swiper-slide swiper-slide-next"
                  data-swiper-slide-index={1}
                  role="group"
                  aria-label="2 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/2.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/2.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Slide End */}
                {/* Slide Start */}
                <div
                  className="swiper-slide"
                  data-swiper-slide-index={2}
                  role="group"
                  aria-label="3 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/3.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/3.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Slide End */}
                {/* Slide Start */}
                <div
                  className="swiper-slide"
                  data-swiper-slide-index={3}
                  role="group"
                  aria-label="4 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/4.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/4.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Slide End */}
                {/* Slide Start */}
                <div
                  className="swiper-slide"
                  data-swiper-slide-index={4}
                  role="group"
                  aria-label="5 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/5.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/5.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Slide End */}
                {/* Slide Start */}
                <div
                  className="swiper-slide swiper-slide-duplicate-prev"
                  data-swiper-slide-index={5}
                  role="group"
                  aria-label="6 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/3.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/3.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Slide End */}
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active"
                  data-swiper-slide-index={0}
                  role="group"
                  aria-label="1 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/1.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/1.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next"
                  data-swiper-slide-index={1}
                  role="group"
                  aria-label="2 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/2.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/2.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={2}
                  role="group"
                  aria-label="3 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/3.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/3.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={3}
                  role="group"
                  aria-label="4 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/4.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/4.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="swiper-slide swiper-slide-duplicate"
                  data-swiper-slide-index={4}
                  role="group"
                  aria-label="5 / 6"
                  style={{ width: "255.4px", marginRight: 18 }}
                >
                  <div className="intagram-card intagram-card2">
                    <div className="img-box">
                      <a
                        href="javascript:void(0)"
                        className="bg-size"
                        style={{
                          backgroundImage:
                            "url(https://themes.pixelstrap.com/oslo/assets/images/bag/instagram/5.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          display: "block"
                        }}
                      >
                        <img
                          className="img-fluid bg-img"
                          src="/assets/images/bag/instagram/5.jpg"
                          alt="instagram"
                          style={{ display: "none" }}
                        />
                      </a>
                      <div className="on-hover">
                        <div className="content-box">
                          <span className="share">
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-plus"
                              >
                                <line x1={12} y1={5} x2={12} y2={19} />
                                <line x1={5} y1={12} x2={19} y2={12} />
                              </svg>
                            </span>{" "}
                            SHARE
                          </span>
                          <div className="option-box">
                            <p>New Offer- 45% Discount</p>
                            <h5>Moonlight Bay Knit</h5>
                            <span className="price">$120</span>
                            <div className="control">
                              <a href="wishlist.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-heart"
                                >
                                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                </svg>
                              </a>
                              <a href="cart.html">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-shopping-bag"
                                >
                                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                  <line x1={3} y1={6} x2={21} y2={6} />
                                  <path d="M16 10a4 4 0 0 1-8 0" />
                                </svg>
                              </a>
                            </div>
                            <a
                              href="shop-left-sidebar.html"
                              className="btn-style2 bg-white"
                            >
                              SHOP NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                className="swiper-notification"
                aria-live="assertive"
                aria-atomic="true"
              />
            </div>
          </section>
          {/* Instagram Section End */}
        </main>
        {/* Main End */}
        {/* Document Footer Start */}
        <footer className="footer-document footer-document2 ratio_asos mb-xxl">
          <div className="bg-footer-l">
            <img src="/assets/images/bag/banner/bg-footer-l.png" alt="banner" />
          </div>
          <div className="bg-footer-r">
            <img src="/assets/images/bag/banner/bg-footer-r.png" alt="banner" />
          </div>
          <div>
            <div className="container-lg">
              <div className="main-footer">
                <div className="row gy-3 gy-md-4 gy-xl-0">
                  <div className="col-xl-3 col-lg-4 col-md-6">
                    <div className="content-box">
                      <img
                        className="logo"
                        src="/assets/images/logos/logo-2.png"
                        alt="logo-white"
                      />
                      <ul>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-map-pin"
                          >
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                            <circle cx={12} cy={10} r={3} />
                          </svg>{" "}
                          <span>
                            {" "}
                            1418 Riverwood Drive, Suite 3245 Cottonwood, CA 96052,
                            United States{" "}
                          </span>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-phone"
                          >
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                          </svg>
                          <a className="nav" href="tel:185659635">
                            <span> + 185659635 </span>
                          </a>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-mail"
                          >
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                            <polyline points="22,6 12,13 2,6" />
                          </svg>
                          <a className="nav" href="mailto:fashion098@gmail.com">
                            <span> fashion098@gmail.com </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="nav-footer col-lg-2 col-md-4 order-md-3 order-lg-2">
                    <div className="nav content-box d-md-block">
                      <h5 className="heading-footer line-style">Shop By</h5>
                      <ul>
                        <li>
                          <a className="nav" href="shop-left-sidebar.html">
                            New In{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="shop-left-sidebar.html">
                            Women{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="shop-left-sidebar.html">
                            Men{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="shop-left-sidebar.html">
                            Shoes
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="shop-left-sidebar.html">
                            Bags &amp; Accessories{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="shop-left-sidebar.html">
                            Top Brands{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="nav-footer col-xl-2 col-lg-3 col-md-4 order-md-4 order-lg-3">
                    <div className="nav d-md-block content-box">
                      <h5 className="heading-footer line-style">Information</h5>
                      <ul>
                        <li>
                          <a className="nav" href="index.html">
                            Home{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="shop-left-sidebar.html">
                            Shop{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="about-us.html">
                            About Us
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="blog-detail.html">
                            Blog{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="contact-us.html">
                            Contact{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="nav-footer col-xl-2 col-lg-3 col-md-4 order-md-5 order-lg-4">
                    <div className="nav d-md-block content-box">
                      <h5 className="heading-footer line-style">Get Help</h5>
                      <ul>
                        <li>
                          <a className="nav" href="user-dashboard.html">
                            Your Orders{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="user-dashboard.html">
                            Your Account{" "}
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="user-dashboard.html">
                            Track Order
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="wishlist.html">
                            Your Wishlist
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="search.html">
                            Search
                          </a>
                        </li>
                        <li>
                          <a className="nav" href="faqs.html">
                            Faqs
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6 col-lg-4 order-md-2 order-lg-5">
                    <div className="content-box">
                      <h5 className="heading-footer line-style">Follow Us</h5>
                      <div className="follow-wrap">
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/">
                              {" "}
                              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" color="white" viewBox="0 0 50 50">
                                <path d="M 30.140625 2 C 26.870375 2 24.045399 2.9969388 22.0625 4.9667969 C 20.079601 6.936655 19 9.823825 19 13.367188 L 19 18 L 13 18 A 1.0001 1.0001 0 0 0 12 19 L 12 27 A 1.0001 1.0001 0 0 0 13 28 L 19 28 L 19 47 A 1.0001 1.0001 0 0 0 20 48 L 28 48 A 1.0001 1.0001 0 0 0 29 47 L 29 28 L 36 28 A 1.0001 1.0001 0 0 0 36.992188 27.125 L 37.992188 19.125 A 1.0001 1.0001 0 0 0 37 18 L 29 18 L 29 14 C 29 12.883334 29.883334 12 31 12 L 37 12 A 1.0001 1.0001 0 0 0 38 11 L 38 3.3457031 A 1.0001 1.0001 0 0 0 37.130859 2.3554688 C 36.247185 2.2382213 33.057174 2 30.140625 2 z M 30.140625 4 C 32.578477 4 34.935105 4.195047 36 4.2949219 L 36 10 L 31 10 C 28.802666 10 27 11.802666 27 14 L 27 19 A 1.0001 1.0001 0 0 0 28 20 L 35.867188 20 L 35.117188 26 L 28 26 A 1.0001 1.0001 0 0 0 27 27 L 27 46 L 21 46 L 21 27 A 1.0001 1.0001 0 0 0 20 26 L 14 26 L 14 20 L 20 20 A 1.0001 1.0001 0 0 0 21 19 L 21 13.367188 C 21 10.22255 21.920305 7.9269075 23.472656 6.3847656 C 25.025007 4.8426237 27.269875 4 30.140625 4 z"></path>
                              </svg>
                            </a>
                          </li>
                          <li>
                            <a href="https://www.instagram.com/accounts/login/?source=auth_switcher">
                              {" "}
                              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" color="white" viewBox="0 0 50 50">
                                <path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
                              </svg>
                            </a>
                          </li>
                          <li>
                            <a href="https://twitter.com/i/flow/login">
                              {" "}
                              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" color="white" viewBox="0 0 50 50">
                                <path d="M 34.21875 5.46875 C 28.238281 5.46875 23.375 10.332031 23.375 16.3125 C 23.375 16.671875 23.464844 17.023438 23.5 17.375 C 16.105469 16.667969 9.566406 13.105469 5.125 7.65625 C 4.917969 7.394531 4.597656 7.253906 4.261719 7.277344 C 3.929688 7.300781 3.632813 7.492188 3.46875 7.78125 C 2.535156 9.386719 2 11.234375 2 13.21875 C 2 15.621094 2.859375 17.820313 4.1875 19.625 C 3.929688 19.511719 3.648438 19.449219 3.40625 19.3125 C 3.097656 19.148438 2.726563 19.15625 2.425781 19.335938 C 2.125 19.515625 1.941406 19.839844 1.9375 20.1875 L 1.9375 20.3125 C 1.9375 23.996094 3.84375 27.195313 6.65625 29.15625 C 6.625 29.152344 6.59375 29.164063 6.5625 29.15625 C 6.21875 29.097656 5.871094 29.21875 5.640625 29.480469 C 5.410156 29.742188 5.335938 30.105469 5.4375 30.4375 C 6.554688 33.910156 9.40625 36.5625 12.9375 37.53125 C 10.125 39.203125 6.863281 40.1875 3.34375 40.1875 C 2.582031 40.1875 1.851563 40.148438 1.125 40.0625 C 0.65625 40 0.207031 40.273438 0.0507813 40.71875 C -0.109375 41.164063 0.0664063 41.660156 0.46875 41.90625 C 4.980469 44.800781 10.335938 46.5 16.09375 46.5 C 25.425781 46.5 32.746094 42.601563 37.65625 37.03125 C 42.566406 31.460938 45.125 24.226563 45.125 17.46875 C 45.125 17.183594 45.101563 16.90625 45.09375 16.625 C 46.925781 15.222656 48.5625 13.578125 49.84375 11.65625 C 50.097656 11.285156 50.070313 10.789063 49.777344 10.445313 C 49.488281 10.101563 49 9.996094 48.59375 10.1875 C 48.078125 10.417969 47.476563 10.441406 46.9375 10.625 C 47.648438 9.675781 48.257813 8.652344 48.625 7.5 C 48.75 7.105469 48.613281 6.671875 48.289063 6.414063 C 47.964844 6.160156 47.511719 6.128906 47.15625 6.34375 C 45.449219 7.355469 43.558594 8.066406 41.5625 8.5 C 39.625 6.6875 37.074219 5.46875 34.21875 5.46875 Z M 34.21875 7.46875 C 36.769531 7.46875 39.074219 8.558594 40.6875 10.28125 C 40.929688 10.53125 41.285156 10.636719 41.625 10.5625 C 42.929688 10.304688 44.167969 9.925781 45.375 9.4375 C 44.679688 10.375 43.820313 11.175781 42.8125 11.78125 C 42.355469 12.003906 42.140625 12.53125 42.308594 13.011719 C 42.472656 13.488281 42.972656 13.765625 43.46875 13.65625 C 44.46875 13.535156 45.359375 13.128906 46.3125 12.875 C 45.457031 13.800781 44.519531 14.636719 43.5 15.375 C 43.222656 15.578125 43.070313 15.90625 43.09375 16.25 C 43.109375 16.65625 43.125 17.058594 43.125 17.46875 C 43.125 23.71875 40.726563 30.503906 36.15625 35.6875 C 31.585938 40.871094 24.875 44.5 16.09375 44.5 C 12.105469 44.5 8.339844 43.617188 4.9375 42.0625 C 9.15625 41.738281 13.046875 40.246094 16.1875 37.78125 C 16.515625 37.519531 16.644531 37.082031 16.511719 36.683594 C 16.378906 36.285156 16.011719 36.011719 15.59375 36 C 12.296875 35.941406 9.535156 34.023438 8.0625 31.3125 C 8.117188 31.3125 8.164063 31.3125 8.21875 31.3125 C 9.207031 31.3125 10.183594 31.1875 11.09375 30.9375 C 11.53125 30.808594 11.832031 30.402344 11.816406 29.945313 C 11.800781 29.488281 11.476563 29.097656 11.03125 29 C 7.472656 28.28125 4.804688 25.382813 4.1875 21.78125 C 5.195313 22.128906 6.226563 22.402344 7.34375 22.4375 C 7.800781 22.464844 8.214844 22.179688 8.355469 21.746094 C 8.496094 21.3125 8.324219 20.835938 7.9375 20.59375 C 5.5625 19.003906 4 16.296875 4 13.21875 C 4 12.078125 4.296875 11.03125 4.6875 10.03125 C 9.6875 15.519531 16.6875 19.164063 24.59375 19.5625 C 24.90625 19.578125 25.210938 19.449219 25.414063 19.210938 C 25.617188 18.96875 25.695313 18.648438 25.625 18.34375 C 25.472656 17.695313 25.375 17.007813 25.375 16.3125 C 25.375 11.414063 29.320313 7.46875 34.21875 7.46875 Z"></path>
                              </svg>
                            </a>
                          </li>
                          <li>
                            <a href="https://in.pinterest.com/">
                              {" "}
                              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" color="white" viewBox="0 0 50 50">
                                <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609825 4 46 13.390175 46 25 C 46 36.609825 36.609825 46 25 46 C 22.876355 46 20.82771 45.682142 18.896484 45.097656 C 19.75673 43.659418 20.867347 41.60359 21.308594 39.90625 C 21.570728 38.899887 22.648438 34.794922 22.648438 34.794922 C 23.348841 36.132057 25.395277 37.263672 27.574219 37.263672 C 34.058123 37.263672 38.732422 31.300682 38.732422 23.890625 C 38.732422 16.78653 32.935409 11.472656 25.476562 11.472656 C 16.196831 11.472656 11.271484 17.700825 11.271484 24.482422 C 11.271484 27.636307 12.94892 31.562193 15.634766 32.8125 C 16.041611 33.001865 16.260073 32.919834 16.353516 32.525391 C 16.425459 32.226044 16.788267 30.766792 16.951172 30.087891 C 17.003269 29.871239 16.978043 29.68405 16.802734 29.470703 C 15.913793 28.392399 15.201172 26.4118 15.201172 24.564453 C 15.201172 19.822048 18.791452 15.232422 24.908203 15.232422 C 30.18976 15.232422 33.888672 18.832872 33.888672 23.980469 C 33.888672 29.796219 30.95207 33.826172 27.130859 33.826172 C 25.020554 33.826172 23.440361 32.080359 23.947266 29.939453 C 24.555054 27.38426 25.728516 24.626944 25.728516 22.78125 C 25.728516 21.130713 24.842754 19.753906 23.007812 19.753906 C 20.850369 19.753906 19.117188 21.984457 19.117188 24.974609 C 19.117187 26.877359 19.761719 28.166016 19.761719 28.166016 C 19.761719 28.166016 17.630543 37.176514 17.240234 38.853516 C 16.849091 40.52931 16.953851 42.786365 17.115234 44.466797 C 9.421139 41.352465 4 33.819328 4 25 C 4 13.390175 13.390175 4 25 4 z"></path>
                              </svg>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="subscribe-box">
                        <h5>Newsletter Sign Up</h5>
                        <p>
                          Receive our latest updates about our products &amp;
                          promotions.
                        </p>
                      </div>
                      <form action="javascript:void(0)" className="footer-form">
                        <input
                          required=""
                          type="email"
                          className="form-control"
                          placeholder="Your email address"
                        />
                        <button type="submit" className="btn-style2 btn-theme mb-0">
                          SUBMIT <i className="arrow" />
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sub-footer">
                <div className="row gy-3">
                  <div className="col-md-6">
                    <ul>
                      <li>
                        <a href="javascript:void(0)">
                          {" "}
                          <img
                            src="/assets/icons/png/1.png"
                            className="img-fluid blur-up lazyload"
                            alt="payment icon"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">
                          {" "}
                          <img
                            src="/assets/icons/png/2.png"
                            className="img-fluid blur-up lazyload"
                            alt="payment icon"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">
                          {" "}
                          <img
                            src="/assets/icons/png/3.png"
                            className="img-fluid blur-up lazyload"
                            alt="payment icon"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">
                          {" "}
                          <img
                            src="/assets/icons/png/4.png"
                            className="img-fluid blur-up lazyload"
                            alt="payment icon"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-0">
                      © 2022, OSLO Template. Made with heart by Pixelstrap
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* Document Footer End */}
        {/* Mobile Menu Footer Start */}
        <footer className="mobile-menu-footer d-sm-none">
          <ul>
            <li>
              <a href="index.html" className="active">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-home"
                >
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
                <span>Home</span>
              </a>
            </li>
            <li>
              <a href="search.html" className="search-link">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-search"
                >
                  <circle cx={11} cy={11} r={8} />
                  <line x1={21} y1={21} x2="16.65" y2="16.65" />
                </svg>
                <span>Search</span>
              </a>
            </li>
            <li>
              <a href="cart.html">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-shopping-bag"
                >
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                  <line x1={3} y1={6} x2={21} y2={6} />
                  <path d="M16 10a4 4 0 0 1-8 0" />
                </svg>
                <span>Cart</span>
              </a>
            </li>
            <li>
              <a href="wishlist.html">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-heart"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                <span>Wishlist</span>
              </a>
            </li>
            <li>
              <a href="user-dashboard.html">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-user"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx={12} cy={7} r={4} />
                </svg>
                <span>Account</span>
              </a>
            </li>
          </ul>
        </footer>
        {/* Mobile Menu Footer End */}
        {/* Notification Start */}
        <div className="notification-wrap addToCart">
          <div className="notification">
            <img src="/assets/images/bag/product/1.jpg" alt="product" />
            <div>
              <h5>Added To Cart</h5>
            </div>
          </div>
        </div>
        {/* Notification End */}
        {/* Notification Start */}
        <div className="notification-wrap addToWishlist">
          <div className="notification">
            <img src="/assets/images/bag/product/1.jpg" alt="product" />
            <div>
              <h5>Added To Wishlist</h5>
            </div>
          </div>
        </div>
        {/* Notification End */}
        {/* View Product Modal Start */}
        <div
          className="modal view-product fade"
          id="viewModal"
          tabIndex={-1}
          aria-labelledby="viewModal"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <span
                  className="close-modal d-none d-md-block"
                  data-bs-toggle="modal"
                  data-bs-target="#viewModal"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-x"
                  >
                    <line x1={18} y1={6} x2={6} y2={18} />
                    <line x1={6} y1={6} x2={18} y2={18} />
                  </svg>
                </span>
                <div className="row gy-4 g-md-0">
                  <div className="col-md-7">
                    <div className="slider-box">
                      <span
                        className="close-modal d-md-none"
                        data-bs-toggle="modal"
                        data-bs-target="#viewModal"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-x"
                        >
                          <line x1={18} y1={6} x2={6} y2={18} />
                          <line x1={6} y1={6} x2={18} y2={18} />
                        </svg>
                      </span>
                      <div className="row g-2">
                        <div className="col-2">
                          <div className="thumbnail-box">
                            <div className="swiper thumbnail-img-box thumbnailSlider swiper-initialized swiper-vertical swiper-pointer-events swiper-thumbs">
                              <div
                                className="swiper-wrapper"
                                id="swiper-wrapper-1308a5fe1bc1bbc6"
                                aria-live="polite"
                                style={{ transitionDuration: "0ms" }}
                              >
                                <div className="swiper-slide">
                                  <img
                                    src="/assets/images/bag/product/8.jpg"
                                    alt="img"
                                  />
                                </div>
                                <div className="swiper-slide">
                                  <img
                                    src="/assets/images/bag/product/8-1.jpg"
                                    alt="img"
                                  />
                                </div>
                                <div className="swiper-slide">
                                  <img
                                    src="/assets/images/bag/product/8-2.jpg"
                                    alt="img"
                                  />
                                </div>
                                <div className="swiper-slide">
                                  <img
                                    src="/assets/images/bag/product/8-3.jpg"
                                    alt="img"
                                  />
                                </div>
                                <div className="swiper-slide">
                                  <img
                                    src="/assets/images/bag/product/8-2.jpg"
                                    alt="img"
                                  />
                                </div>
                              </div>
                              <span
                                className="swiper-notification"
                                aria-live="assertive"
                                aria-atomic="true"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-10 ratio_square">
                          <div className="swiper mainslider swiper-initialized swiper-horizontal swiper-pointer-events">
                            <div
                              className="swiper-wrapper"
                              id="swiper-wrapper-abfa75b3b5bf5ea8"
                              aria-live="polite"
                              style={{ transitionDuration: "0ms" }}
                            >
                              <div
                                className="swiper-slide bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/8.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="bg-img"
                                  src="/assets/images/bag/product/8.jpg"
                                  alt="img"
                                  style={{ display: "none" }}
                                />
                              </div>
                              <div
                                className="swiper-slide bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/8-1.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="bg-img"
                                  src="/assets/images/bag/product/8-1.jpg"
                                  alt="img"
                                  style={{ display: "none" }}
                                />
                              </div>
                              <div
                                className="swiper-slide bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/8-2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="bg-img"
                                  src="/assets/images/bag/product/8-2.jpg"
                                  alt="img"
                                  style={{ display: "none" }}
                                />
                              </div>
                              <div
                                className="swiper-slide bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/8-3.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="bg-img"
                                  src="/assets/images/bag/product/8-3.jpg"
                                  alt="img"
                                  style={{ display: "none" }}
                                />
                              </div>
                              <div
                                className="swiper-slide bg-size"
                                style={{
                                  backgroundImage:
                                    "url(https://themes.pixelstrap.com/oslo/assets/images/bag/product/8-2.jpg)",
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  backgroundRepeat: "no-repeat",
                                  display: "block"
                                }}
                              >
                                <img
                                  className="bg-img"
                                  src="/assets/images/bag/product/8-2.jpg"
                                  alt="img"
                                  style={{ display: "none" }}
                                />
                              </div>
                            </div>
                            <span
                              className="swiper-notification"
                              aria-live="assertive"
                              aria-atomic="true"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="product-detail-box">
                      <div className="product-option">
                        <h4>Beige Solid Sling Bag</h4>
                        <div className="option price">
                          <h5>Price</h5>
                          <span> $200.00 </span> <del>$300.00</del>
                        </div>
                        <div className="option">
                          <h5>Product Description</h5>
                          <p className="content-color">
                            To create timeless products, quality is foremost. That's
                            why, we have hand-picked and sourced our artisans,
                            leather, threads and all other materials of the very best
                            quality.
                          </p>
                        </div>
                        <div className="option">
                          <h5>Your Brand Color:</h5>
                          <ul className="color-list">
                            <li className="bg-theme-p-1 active" />
                            <li className="bg-theme-p-2" />
                            <li className="bg-theme-p-3" />
                          </ul>
                        </div>
                        <div className="option">
                          <h5>Quantity:</h5>
                          <div className="plus-minus">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-minus sub"
                            >
                              <line x1={5} y1={12} x2={19} y2={12} />
                            </svg>
                            <input type="number" defaultValue={1} min={1} max={10} />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-plus add"
                            >
                              <line x1={12} y1={5} x2={12} y2={19} />
                              <line x1={5} y1={12} x2={19} y2={12} />
                            </svg>
                          </div>
                        </div>
                        <div className="btn-group">
                          <a
                            href="javascript:void(0)"
                            data-bs-toggle="modal"
                            data-bs-target="#viewModal"
                            className="btn-solid btn-sm addtocart-btn"
                          >
                            Add To Cart{" "}
                          </a>
                          <a href="product.html" className="btn-outline btn-sm">
                            View Full
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* View Product Modal End */}
        {/* Cookies Section Start */}
        <div className="cookie-bar cookies-bar-1 left-cookies">
          <img src="/assets/png/cookie.png" alt="cookies" />
          <div className="content">
            <h5>Cookies Consent</h5>
            <p>
              This website use cookies to ensure you get the best experience on our
              website.
            </p>
            <div className="cookie-buttons">
              <button className="btn-solid btn-sm mb-line cookies-accept">
                Accept <i className="arrow" />
              </button>
              <a
                href="javascript:void(0)"
                className="btn-solid btn-sm btn-outline cookies-accept"
              >
                Learn more
              </a>
            </div>
          </div>
        </div>
        {/* Cookie Section End */}
        {/* Tap To Top Button Start */}
        <div className="tap-to-top-box hide">
          <button className="tap-to-top-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-chevrons-up"
            >
              <polyline points="17 11 12 6 7 11" />
              <polyline points="17 18 12 13 7 18" />
            </svg>
          </button>
        </div>
        {/* Tap To Top Button End */}
        {/* Bootstrap Js */}
        {/* Feather Icon */}
        {/* Swiper Slider Js */}
        {/* Timer Js */}
        {/* Header Sticky js  */}
        {/* Active Class js  */}
        {/* Wow Js */}
        {/* Script Js */}
        {/* Theme Settings Js */}
        <div id="veepn-breach-alert" />
        <style
          dangerouslySetInnerHTML={{
            __html:
              '@font-face{font-family:FigtreeVF;src:url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2) format("woff2 supports variations"),url(chrome-extension://majdfhpaihoncoakbjgbdhglocklcgno/fonts/FigtreeVF.woff2) format("woff2-variations");font-weight:100 1000;font-display:swap}'
          }}
        />
      </>


    </>
  );
}

export default App;
